import { render } from "./status_content.vue?vue&type=template&id=22fbd1e4"
import script from "./status_content.js?vue&type=script&lang=js"
export * from "./status_content.js?vue&type=script&lang=js"

import "./status_content.vue?vue&type=style&index=0&id=22fbd1e4&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__